import { render } from "./CenterClinicDetail.vue?vue&type=template&id=b8afdbba"
import script from "./CenterClinicDetail.vue?vue&type=script&lang=js"
export * from "./CenterClinicDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__